import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Config from '../../app.config';

const FooterGetApp = () => (
  <div className="home-join__row" id="homeJoinPhone">
    <div className="home-join__col home-join__col-lr home-join__col-l">
      <div className="home-join__left-inner">
        <div className="home-join__left-title">
          <span title="It’s Easy" className="header-font">
            It’s Easy
          </span>
          <span className="home-join__left-text">Peasy</span>
          <span title="Squeezy" className="header-font">
            Squeezy
          </span>
        </div>
      </div>
    </div>

    <div className="home-join__col home-join__col-md hide-phone">
      <div className="home-join__img ir">
        <span className="home-join__gettheapp">
          <img
            src={`${Config.awsCloudFrontUrl}/svg/gettheapp.svg`}
            alt="Get The App Bubble"
          />
        </span>
        <img
          id="homeJoinImg"
          className="lazyload"
          width="110px"
          height="530px"
          src={`${Config.awsCloudFrontUrl}/images/phone.png`}
          alt="Get The App"
        />
      </div>
    </div>

    <div className="home-join__col home-join__col-lr home-join__col-r">
      <div className="home-join__right-inner">
        <div className="appScanner hide-phone">
          <p>scan this code</p>
          <div
            style={{
              color: '#8DD1D8',
              fontSize: '1.2rem',
              fontWeight: 700,
              marginBottom: '1rem',
            }}
          >
            TO DOWNLOAD THE APP
          </div>
          <img
            src={`${Config.awsCloudFrontUrl}/images/app-scanner.png`}
            alt="QR Scanner App link"
          />
        </div>
        <button className="btn btn--secondary home__btn hide-desktop mb20">
          <a
            href="https://apps.apple.com/us/app/squeeze-massage/id1365731550"
            target="_blank"
            className="appLink"
          >
            DOWNLOAD THE APP
          </a>
        </button>
        <a href="/#">
          <i className="icon-home icon-home--appstore" />
          <span className="screenreader">
            Available on the iPhone App Store
          </span>
        </a>
      </div>
    </div>

    <div className="home-join__col home-join__col-md phone-only">
      <div className="home-join__img ir">
        <span className="home-join__gettheapp">
          <img
            src={`${Config.awsCloudFrontUrl}/svg/gettheapp.svg`}
            alt="Get The App Bubble"
          />
        </span>
      </div>
    </div>
  </div>
);

FooterGetApp.propTypes = {};

export default compose(withRouter)(FooterGetApp);
